import { useFormik } from "formik";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import toast from "react-hot-toast";
import { formValidate } from "../../../../helper/validate";

import * as api from "helper/helper";
import { formikExtra } from "../../helperFunctions/helpers";

const DevolucionOrdenVentaModal = forwardRef(({ item, onOk, reload }, ref) => {
  const modalButtonRef = useRef();

  const [canSave, setCanSave] = useState(false);

  useImperativeHandle(ref, () => ({
    toggleModal: () => {
      formik?.resetForm();
      modalButtonRef.current.click();

      setCanSave(false);
    },
  }));

  //
  //let montoActual = item?.actual ?? 0;
  let initialValues = {
    montoNuevo: "0",
    mensaje: "",
  };

  if (item) {
    initialValues = {
      montoNuevo: "0",
      mensaje: "",
    };
  }

  useEffect(() => {
    setCanSave(false);
  }, [item]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: formValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      //is - invalid;

      //const className = `nav-link collapsed ${isSelected ? "selected" : ""}`;
      //console.log(values);
      //setUsername(values.username);
      //navigate("/password");

      if (values.id) {
        let cancelaOrdenPromise = api.ordenVentaCancela(values.id);
        toast.promise(cancelaOrdenPromise, {
          loading: "Actualizando Usuario...",
          success: <b>Usuario Actualizado...!</b>,
          error: <b>Error al Actualizar Usuario</b>,
        });

        cancelaOrdenPromise.then((res) => {
          console.log("");
          reload();

          formik.resetForm();

          //buttonCancelModalRef.current.click();
        });

        return;
      }
    },
  });

  return (
    <>
      {/*<!-- Button trigger modal -->*/}
      <button
        ref={modalButtonRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropDevolucionOrden"
        hidden
      >
        Launch static backdrop modal
      </button>

      {/*<!-- Modal -->*/}
      <div
        className="modal fade"
        id="staticBackdropDevolucionOrden"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropDevolucionOrdenLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="staticBackdropDevolucionOrdenLabel"
              >
                Solicitar Devolución de Orden de Venta
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form className="row" onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <div className="mb-3">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Deja Mensaje para Revisión"
                        id="floatingTextarea2"
                        {...formik.getFieldProps("mensaje")}
                        {...formikExtra.upperCase("mensaje", formik)}
                        onChange={(event) => {
                          //      onChange={(e)=>{ const value = e.target.value || ""; setFieldValue('email', value.toLowerCase()); }}
                          const value = event.target.value || "";
                          formik.setFieldValue("mensaje", value.toUpperCase());

                          //    const option = parseFloat(e.target.value);
                          //          formik.setFieldValue("montoNuevo", e.target.value);

                          setCanSave(value.length > 3);
                        }}
                        style={{ height: "100px" }}
                      ></textarea>
                      <label htmlFor="floatingTextarea2">Mensaje</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                type="button"
                disabled={!canSave}
                onClick={async () => {
                  //const value = formik.getFieldProps("montoNuevo").value;
                  const ordenVentaId = item.id;

                  const toastId = toast.loading("Solicitando...");
                  const response = await api
                    .asociadosSolicitudesCreate({
                      tipoDeSolicitud: "OrdenVentaDevolucion",
                      fecha: new Date().toJSON(),
                      mensaje: formik.values.mensaje,
                      ordenVentaId: ordenVentaId,
                    })
                    .catch((e) => {
                      toast.dismiss(toastId);
                      if (e.esError && e.codigoError && e.mensaje) {
                        toast.error(`${e.mensaje}`);
                        return;
                      }
                      toast.error(
                        "Error al Solicitar Cambio Limite de Credito",
                      );
                    });

                  toast.dismiss(toastId);

                  if (!response) return;

                  modalButtonRef.current.click();
                  toast.success(
                    <b>
                      Se Realizo Solicitud de Cancelacion de Orden de Venta
                    </b>,
                  );
                }}
              >
                Solicitar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default DevolucionOrdenVentaModal;
